module.exports = __webpack_public_path__ + "media/images/pic/labels/materials/doki-doki-1-5312dd27a6730624ec07a99cfb37e424.jpg";